/* tslint:disable */
/* eslint-disable */
/**
 * SLOeats API
 * Interal API to the SLOeats platform.
 *
 * The version of the OpenAPI document: 
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface DealReward
 */
export interface DealReward {
    /**
     * 
     * @type {number}
     * @memberof DealReward
     */
    readonly id: number;
    /**
     * 
     * @type {string}
     * @memberof DealReward
     */
    readonly name: string;
    /**
     * 
     * @type {string}
     * @memberof DealReward
     */
    readonly description: string;
    /**
     * 
     * @type {number}
     * @memberof DealReward
     */
    readonly price: number;
    /**
     * 
     * @type {number}
     * @memberof DealReward
     */
    readonly amount_saved: number;
    /**
     * 
     * @type {string}
     * @memberof DealReward
     */
    readonly image: string;
    /**
     * 
     * @type {boolean}
     * @memberof DealReward
     */
    readonly is_archived: boolean;
    /**
     * The ID of the reel associated with this reward. Corresponds to the YouTube video ID.
     * @type {string}
     * @memberof DealReward
     */
    readonly reel_id: string;
    /**
     * The Mux playback ID for the video associated with this reward.
     * @type {string}
     * @memberof DealReward
     */
    readonly mux_playback_id: string;
    /**
     * 
     * @type {string}
     * @memberof DealReward
     */
    readonly mux_signed_video_token: string | null;
    /**
     * 
     * @type {string}
     * @memberof DealReward
     */
    readonly mux_signed_thumbnail_token: string | null;
    /**
     * 
     * @type {string}
     * @memberof DealReward
     */
    readonly food_cost: string | null;
    /**
     * 
     * @type {string}
     * @memberof DealReward
     */
    readonly cook_time: string | null;
}

/**
 * Check if a given object implements the DealReward interface.
 */
export function instanceOfDealReward(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "id" in value;
    isInstance = isInstance && "name" in value;
    isInstance = isInstance && "description" in value;
    isInstance = isInstance && "price" in value;
    isInstance = isInstance && "amount_saved" in value;
    isInstance = isInstance && "image" in value;
    isInstance = isInstance && "is_archived" in value;
    isInstance = isInstance && "reel_id" in value;
    isInstance = isInstance && "mux_playback_id" in value;
    isInstance = isInstance && "mux_signed_video_token" in value;
    isInstance = isInstance && "mux_signed_thumbnail_token" in value;
    isInstance = isInstance && "food_cost" in value;
    isInstance = isInstance && "cook_time" in value;

    return isInstance;
}

export function DealRewardFromJSON(json: any): DealReward {
    return DealRewardFromJSONTyped(json, false);
}

export function DealRewardFromJSONTyped(json: any, ignoreDiscriminator: boolean): DealReward {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'name': json['name'],
        'description': json['description'],
        'price': json['price'],
        'amount_saved': json['amount_saved'],
        'image': json['image'],
        'is_archived': json['is_archived'],
        'reel_id': json['reel_id'],
        'mux_playback_id': json['mux_playback_id'],
        'mux_signed_video_token': json['mux_signed_video_token'],
        'mux_signed_thumbnail_token': json['mux_signed_thumbnail_token'],
        'food_cost': json['food_cost'],
        'cook_time': json['cook_time'],
    };
}

export function DealRewardToJSON(value?: DealReward | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
    };
}

